<template>
  <v-card class="panel-card" outlined>
    <v-card-title class="text-h6 font-weight-bold">连接设置</v-card-title>
    <v-card-text>
      <v-text-field :value="config.brokerUrl" label="WebSocket Broker 地址" outlined dense hide-details class="mb-3" @input="updateConfig('brokerUrl', $event)" />
      <v-text-field :value="config.commandTopic" label="命令 Topic" outlined dense hide-details class="mb-3" @input="updateConfig('commandTopic', $event)" />
      <v-expansion-panels flat accordion class="advanced-settings mb-3">
        <v-expansion-panel>
          <v-expansion-panel-header class="px-0 py-2">更多连接参数</v-expansion-panel-header>
          <v-expansion-panel-content class="px-0">
            <v-text-field :value="config.responseTopic" label="响应 Topic" outlined dense @input="updateConfig('responseTopic', $event)" />
            <v-text-field :value="config.statusTopic" label="状态 Topic" outlined dense @input="updateConfig('statusTopic', $event)" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row dense>
        <v-col cols="6"><v-text-field :value="config.strip" type="number" min="0" label="灯带编号" outlined dense @input="updateNumber('strip', $event)" /></v-col>
        <v-col cols="6"><v-text-field :value="config.index" type="number" min="0" label="灯珠编号" outlined dense @input="updateNumber('index', $event)" /></v-col>
      </v-row>
      <div class="d-flex">
        <v-btn v-if="!connected" :loading="connecting" color="primary" block depressed @click="$emit('connect')"><v-icon left>mdi-lan-connect</v-icon>连接设备</v-btn>
        <v-btn v-else color="secondary" block outlined @click="$emit('disconnect')"><v-icon left>mdi-lan-disconnect</v-icon>断开连接</v-btn>
      </div>
      <v-alert v-if="connectionError" type="error" dense text class="mt-3 mb-0">{{ connectionError }}</v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'MqttConnectionPanel',
  props: {
    config: { type: Object, required: true },
    connected: Boolean,
    connecting: Boolean,
    connectionError: { type: String, default: '' }
  },
  methods: {
    updateConfig (key, value) { this.$emit('update-config', key, value) },
    updateNumber (key, value) { this.$emit('update-config', key, Number(value)) }
  }
}
</script>

<style scoped>
.panel-card { border-color: #dfe3e8 !important; }
.advanced-settings::v-deep .v-expansion-panel-content__wrap { padding: 0; }
</style>
